import script from "./RadioFlags.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioFlags.vue?vue&type=script&setup=true&lang=js"

import "./RadioFlags.vue?vue&type=style&index=0&id=d82040c8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d82040c8"]])

export default __exports__